import { defineStore } from 'pinia'
import { api, post } from '../services/api'



export const useSessionStore = defineStore('session', {
  state: () => ({ user: null, ready: false, authOpen: false, error: '' }),
  getters: {
    label: state => state.user && !state.user.guest ? state.user.display_name : 'Войти',
    isAdmin: state => state.user?.role === 'admin'
  },
  actions: {
    async bootstrap() {
      this.ready = false; this.error = ''
      try {
        const token = localStorage.getItem('promptguess-token')
        this.accept(token ? await api('/me') : await post('/sessions/guest', { display_name: 'Гость' }))
      } catch {
        try { this.accept(await post('/sessions/guest', { display_name: 'Гость' })) }
        catch { this.user = null; this.error = 'Не удалось подключиться к серверу' }
      } finally { this.ready = Boolean(this.user) }
    },
    accept(data) {
      this.user = data.user
      if (data.token) localStorage.setItem('promptguess-token', data.token)
    },
    async requestCode(email) { return post('/sessions/email', { email }) },
    async verify(email, code) {
      this.accept(await post('/sessions/email/verify', { email, code }))
      this.authOpen = false
    },
    async logout() {
      try { await api('/session', { method: 'DELETE' }) } catch {}
      localStorage.removeItem('promptguess-token')
      this.user = null
      await this.bootstrap()
    }
  }
})
